// in src/posts.js
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { CardActions } from '@mui/material';
import { Create } from 'react-admin';
import { OnlyShowActionsDetail } from './FieldComponents/OnlyShowActions';
import Constants from './../shared/constants';
import { getAuthApp } from '../services/security/authApp';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import TextFieldFrom from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { DateTimePicker } from '@mui/x-date-pickers';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

export const ListaCuponesReporte = (props) => {
    const [loterias, setLoterias] = useState([]);
    const [cupones, setCupones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [nombreCupon, setNombreCupon] = useState('');
    const [idLoteria, setidLoteria] = useState('');
    const [estado, setEstado] = useState('');

    const [fechaInicioError, setFechaInicioError] = useState('');
    const [fechaFinError, setFechaFinError] = useState('');

    const handleFechaInicioChange = (date) => {
        setFechaInicio(date);
        setFechaInicioError('');
    };

    const handleFechaFinChange = (date) => {
        setFechaFin(date);
        setFechaFinError('');
    };

    const handleNombreCuponChange = (event, value) => {
        setNombreCupon(value);
    };

    const handleProductoChange = (event, value) => {
        setidLoteria(value);
    };

    const handleEstadoChange = (event, value) => {
        setEstado(value);
    };

    useEffect(() => {
        const fetchLoterias = async () => {
            try {
                const authToken = getAuthApp();
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', `${authToken}`);
                const url = Constants.general.serverURL + "/api/Users/etn/consultar-loterias-disponibles";

                const values = {
                    evento: null,
                    fecha: "11-04-2018"
                };

                const response = await fetch(url, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({ lottery: { ...values } }, null, 2)
                });

                if (response.ok) {
                    const responseData = await response.json();
                    const loteriasData = responseData.data;
                    const loteriasWithAllOption = ['Todos', ...loteriasData.map(item => `${item.ideLoteria} - ${item.desLoteria}`)];
                    setLoterias(loteriasWithAllOption);
                    setLoading(false);
                } else {
                    throw new Error('Error al obtener los productos');
                }
            } catch (error) {
                console.error(error);
            }
        };

        const fetchCupones = async () => {
            try {
                const authToken = getAuthApp();
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', `${authToken}`);
                const urlCupones = Constants.general.serverURL + "/api/cupones";

                const responseCupones = await fetch(urlCupones, {
                    method: 'GET',
                    headers: headers,
                });

                if (responseCupones.ok) {
                    const cuponesData = await responseCupones.json();
                    const nombresCupones = [...cuponesData.map((item) => item.nombre_cupon)];
                    setCupones(nombresCupones);
                } else {
                    throw new Error('Error al obtener los cupones');
                }
            } catch (error) {
                console.error(error);
            }
        };

        const fetchData = async () => {
            setLoading(true);
            await Promise.all([fetchLoterias(), fetchCupones()]);
            setLoading(false);
        };

        fetchData();
    }, []);

    useEffect(() => {
        const fetchLoterias = async () => {
            try {
                const authToken = getAuthApp();
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', `${authToken}`);
                const url = Constants.general.serverURL + "/api/cupones";

                const response = await fetch(url, {
                    method: 'GET',
                    headers: headers,
                });

                if (response.ok) {
                    const responseCupon = await response.json();
                    const CuponesData = responseCupon.data;
                    const CuponesWithAllOption = [...CuponesData.map(item => item.nombre_cupon)];
                    setCupones(CuponesWithAllOption);
                    setLoading(false);
                } else {
                    throw new Error('Error al obtener los cupones');
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchLoterias();
    }, []);

    const handleExportExcelprueba = () => {
        try {
            const authToken = getAuthApp();

            const headers = new Headers();
            headers.append('Authorization', `${authToken}`);

            const downloadURL = Constants.general.serverURL + "/api/cupones/csvexport/xmls";

            fetch(downloadURL, {
                method: 'GET',
                headers: headers
            })
                .then(response => {
                    if (response.ok) {
                        response.blob().then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = 'Cupones.xlsx';
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(url);
                        });
                    } else {
                        throw new Error('Error al descargar el archivo');
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        } catch (error) {
            console.error(error);
        }
    };

    const handleExportExcel = () => {
        try {
            const authToken = getAuthApp();
            const headers = new Headers();
            headers.append('Authorization', `${authToken}`);
            let downloadURL = Constants.general.serverURL + '/api/cuponesredimir/csvexport/xmls';

            const queryParams = [];
            if (fechaInicio) {
                const formattedFechaInicio = new Date(fechaInicio).toISOString().substring(0, 10);
                queryParams.push(`fecha_hora_inicio=${formattedFechaInicio}`);
            }
            if (fechaFin) {
                const formattedFechaFin = new Date(fechaFin).toISOString().substring(0, 10);
                queryParams.push(`fecha_hora_final=${formattedFechaFin}`);
            }
            if (nombreCupon) {
                queryParams.push(`nombre_cupon=${nombreCupon}`);
            }
            if (idLoteria) {
                queryParams.push(`idLoteria=${idLoteria}`);
            }
            if (estado) {
                queryParams.push(`estado_cupon=${estado}`);
            }

            if (queryParams.length > 0) {
                downloadURL += `?${queryParams.join('&')}`;
            }

            fetch(downloadURL, {
                method: 'GET',
                headers: headers,
            })
                .then((response) => {
                    if (response.ok) {
                        response.blob().then((blob) => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = 'Reporte_Cupones.xlsx';
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(url);
                        });
                    } else {
                        throw new Error('Error al descargar el archivo');
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        } catch (error) {
            console.error(error);
        }
    };

    const handleFunction = () => {
        let isValid = true;

        if (!fechaInicio) {
            setFechaInicioError('Por favor, seleccione una fecha de inicio.');
            isValid = false;
        }

        if (!fechaFin) {
            setFechaFinError('Por favor, seleccione una fecha de fin.');
            isValid = false;
        }

        if (fechaInicio && fechaFin && fechaFin < fechaInicio) {
            setFechaFinError('Fecha Final es mayor a la fecha Inicial');
            isValid = false;
        }

        if (isValid) {
            handleExportExcel();
        }
    };

    const ActionsListCupones_Reportes = () => {
        return (
            <CardActions style={cardActionStyle}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleFunction}
                >
                    Exportar Excel
                </Button>
            </CardActions>
        );
    };

    return (
        <Create {...props} title="Reporte Cupones" actions={<ActionsListCupones_Reportes />}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '20px', paddingTop: '20px' }}>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: 'repeat(2, 1fr)',
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box>
                            <DatePicker
                                label="Fecha Inicio*"
                                value={fechaInicio}
                                onChange={handleFechaInicioChange}
                                renderInput={(props) => <TextFieldFrom {...props} />}
                            />
                            {fechaInicioError && <span className="error-message">{fechaInicioError}</span>}
                        </Box>
                        <Box>
                            <DatePicker
                                label="Fecha Fin*"
                                value={fechaFin}
                                onChange={handleFechaFinChange}
                                renderInput={(props) => <TextFieldFrom {...props} />}
                            />
                            {fechaFinError && <span className="error-message">{fechaFinError}</span>}
                        </Box>
                    </LocalizationProvider>
                    {!loading ? (
                        Array.isArray(cupones) && cupones.length > 0 ? (
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                value={nombreCupon}
                                onChange={handleNombreCuponChange}
                                options={cupones}
                                renderInput={(params) => <TextFieldFrom {...params} label="Nombre Cupón" />}
                            />
                        ) : (
                            <p style={{ textAlign: 'center' }}>Nombres no disponibles.</p>
                        )
                    ) : (
                        <p>Cargando nombres cupones...</p>
                    )}
                    {!loading ? (
                        Array.isArray(loterias) && loterias.length > 0 ? (
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                value={idLoteria}
                                onChange={handleProductoChange}
                                options={loterias}
                                renderInput={(params) => <TextFieldFrom {...params} label="Producto" />}
                            />
                        ) : (
                            <p style={{ textAlign: 'center' }}>Loterías no disponibles.</p>
                        )
                    ) : (
                        <p>Cargando loterías...</p>
                    )}
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        value={estado}
                        onChange={handleEstadoChange}
                        options={["ACTIVO", "INACTIVO"]}
                        renderInput={(params) => <TextFieldFrom {...params} label="Estado" />}
                    />
                </Box>
                <style>{`
                    .error-message {
                    display: block;
                    margin-top: 0.5rem;
                    color: red;
                    font-size: 0.8rem;
                    }
                `}</style>
            </div>
        </Create>
    );
};

